import {
  isLinkContent,
  isRepeatableContent,
  LinkContent,
  type NestableContent,
  type RepeatableContent,
} from "@prismicio/types-internal/lib/content"

export function getRepeatableContent(
  content: NestableContent | undefined,
): RepeatableContent | undefined {
  // Repeatable Link with correct content
  if (isRepeatableContent(content)) return content
  // Previously was a Link and now is a Repeatable Link
  if (isLinkContent(content)) {
    return {
      __TYPE__: "RepeatableContent",
      type: "Link",
      value: [content],
    }
  }

  return undefined
}

export function getLinkContent(
  content: NestableContent | undefined,
): LinkContent | undefined {
  // Link with correct content
  if (isLinkContent(content)) return content
  // Previously was a Repeatable Link and now is a Link
  if (isRepeatableContent(content)) {
    const [firstLink] = content.value
    if (isLinkContent(firstLink)) return firstLink
  }

  return undefined
}
